import { api } from './client';

export async function logPdfError(payload: {
  lesson_id: string;
  stage: string;
  reason: string;
  device: string;
}): Promise<void> {
  try {
    await api.post('/uploads/pdf-error', payload);
  } catch {
    /* pencatatan tidak boleh mengganggu pembaca */
  }
}

export async function uploadPdf(
  file: File,
  onProgress?: (percent: number) => void,
): Promise<{ url: string; path: string; name: string; size: number }> {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await api.post<{ url: string; path: string; name: string; size: number }>('/uploads/pdf', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return data;
}

export async function uploadImage(file: File): Promise<{ url: string; path: string }> {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await api.post<{ url: string; path: string }>('/uploads/image', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}
